A partner organization for a `self` query.
